<template>
    <div class="store" :class="{brandStyle:searchType===0}" ref="BigMain">
        <navigation-bar Bell Search :searchText="'今天想找什麼呢？'"/>
        <div class="tabs">
            <div :class="{active: activeName === 'first'}" @click="onTabClick('first')"><span>附近店家</span></div>
            <div :class="{active: activeName === 'second'}" @click="onTabClick('second')"><span>熱門品牌</span></div>
            <div :class="{active: activeName === 'third'}" @click="onTabClick('third')"><span>最新店家</span></div>
        </div>

        <div class="main pt-3" ref="main">
            <!--todo 第一層分類icon和第二層分類-->
            <template v-if="true">
                <quick-menu :list="typeList" :defIcon="getFilterBtnName()" class="mb-0 pt-0" @clickItem="onFilterTabClick"/>
                <div  class="tag-btn-list" v-show="tagList.length > 0" >
                    <div class="text" >
                        <el-button type="text" v-for="(item, index) in tagList" :class="['tag-btn', isTagActive(item.name)? 'active':'']"  :key="index" @click="onTagClick(item)">#{{item.name}}</el-button>
                    </div>
                    <div class="more" @click="tagOpen"/>
                </div>
            </template>
            <!--todo searchType為0 品牌使用-->
            <div v-if="searchType === 0" class="mt-2 mb-2 pb-5">
              <article-cover :list="brandList" :shopType="'brand'" hideStar/>
            </div>
            <div v-if="searchType === 1 || searchType === 2" class="mt-2 mb-2 pb-5">
              <article-cover :list="storeList" :showRemark="isShowRemark" :remark="getRemark" :shopType="'store'" hideStar/>
            </div>
            <infinite-loading @infinite="setupDataScroll" :identifier="infiniteInfinite" ref="infiniteLoading" spinner="waveDots" v-if="setupListData">
              <div slot="no-more">沒有更多資料</div>
              <span slot="no-results"/>
            </infinite-loading>
        </div>
        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
        <!--<comm-dialog :value="dialog.isShowDialog"
                     :outerContent="dialog.dialogMsg"
                     :isModal="false"
                     class="dialog-dark"
                     :isCancel="dialog.cancelable"
                     @result="onCommDialogClose"/>-->
        <toast/>
    </div>
</template>

<script>
    import * as mutationTypes from '@/store/mutationTypes'
    import Toast from "@/components/Toast"
    import ArticleCover from '@/components/article/ArticleCover'
    import QuickMenu from '@/components/QuickMenu';
    //import CommDialog from "@/components/CommDialog";

    export default {
        name: "Store",
        components: {
            ArticleCover,
            Toast,
            QuickMenu,
            //CommDialog,
        },
        data() {
            return {
                isLoading: false,
                lng: 0,
                lat: 0,
                pageSize: 10,
                currentPage: 0,
                activeName: this.$route.query.activeName?this.$route.query.activeName:'first',
                typeList: [],       //第一層分類, type 的種類list
                tagList: [],       //第二層分類, tag 的種類list
                brandList : [],
                storeList: [],
                searchType: this.$route.query.searchType?Number(this.$route.query.searchType):2,
                filterTab: null,      //點選到的第一層分類
                filterTag: null,      //點選到的第二層分類
                setupListData: false,
                infiniteInfinite: 0,
                infiniteLoadingListState: '',
                scrollTo: '',
                offsetHeight: 0,
                //isLogin: this.$auth.isAdminLogin(),
                //dialog 用
                /*dialog: {
                    isShowDialog: false,
                    dialogMsg: '',
                    cancelable: false,
                },*/
            }
        },
        computed: {

        },
        created() {

        },
        mounted() {
            //if (!this.isLogin) {
                //this.showDialog(`請先登入`, true);
            //} else {

                let self = this;

                //讀取資料
                //如果有傳入預設的 tab參數，就跳 tab
                let defaultTab = this.$route.query.defaultTab;
                if (self.$public.notNull(defaultTab) && defaultTab === 'third') {
                    setTimeout(() => {
                        self.onTabClick('third');
                    }, 300)
                } else {
                    this.setupDataWithSnap();
                }
                // this.setupData();


                this.getStoreTypeList()
                    .then((data) => {
                        self.typeList = data;
                    })
                    .catch((error) => {
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });
            //}
            window.onresize = () => {
                //電腦版打橫時，載入更多reset
                if (this.$refs.infiniteLoading) {
                    this.$refs.infiniteLoading.stateChanger.reset();
                }
            }
        },
        updated: function (params) {
            // console.log(`!!! updated , scrollTo:${this.scrollTo}, offsetHeight = ${this.offsetHeight}`);
            // 渲染完成後等一下才捲到目標位置
            setTimeout(() => {
                //回復店家列表捲動狀態
                this.restoreScroll();
            }, 100);
        },
        beforeRouteEnter: function(to, from, next) {
            next(
                vm=>{
                    // vm就是出去的this，先把來的路由存起來，出去就抓不到了？
                    vm.fromRoute = from;
                }
            );
        },
        beforeRouteLeave: function(to, from, next) {
            // 如果是'BrandInfo','StoreInfo','Notify'的話就記住快照
            if (['BrandInfo','StoreInfo','Notify'].indexOf(to.name) !== -1) {
                this.saveSnapshot(from.name);
                // console.log(`router.from :${from}, router.to :${to}`);
            }
            next();
        },
        methods: {
            /** 本頁資料的讀取 */
            setupDataWithSnap: function() {
                //有快照且是來自'BrandInfo','StoreInfo','Notify'的話就用快照的資料，不是的話就重撈
                if ((this.$public.notNull(this.fromRoute) && ['BrandInfo','StoreInfo','Notify'].indexOf(this.fromRoute.name) === -1) ||
                    !this.$public.notNull(this.$store.state.pageSnapshot[this.$route.name])) {

                    this.setupData();

                }else{
                    if (this.hasSnapshot()) {
                        // console.log(`setupDataWithSnap hasSnapshot !`);
                        this.restoreSnapshot();
                        this.startLoading();
                    } else {
                        // console.log(`setupDataWithSnap hasSnapshot !`);
                        this.setupData();
                    }
                }
            },

            /** 儲存本頁的資料到暫存中 */
            saveSnapshot: function(routeName) {

                //手機版紀錄捲動位置
                let object = this.$refs.main

                //網頁版紀錄捲動位置
                const fullWidth = window.innerWidth;
                if(fullWidth>=1024){
                    object = this.$refs.BigMain
                }

                if (this.$public.notNull(object)) {
                    this.scrollTo = object.scrollTop;
                    this.offsetHeight = object.offsetHeight;
                }

                this.$store.commit("savePageSnapshot",
                    {
                        routeName:routeName,
                        variable:{
                            lng : this.lng,
                            lat : this.lat,
                            currentPage : this.currentPage,
                            activeName : this.activeName,
                            typeList : this.typeList,       //第一層分類, type 的種類list
                            tagList : this.tagList,       //第二層分類, tag 的種類list
                            brandList : this.brandList,
                            storeList : this.storeList,
                            searchType : this.searchType,
                            filterTab : this.filterTab,      //點選到的第一層分類
                            filterTag : this.filterTag,      //點選到的第二層分類
                            setupListData : this.setupListData,
                            //infiniteLoadingListState : this.infiniteLoadingListState,
                            scrollTo : this.scrollTo,
                            offsetHeight : this.offsetHeight,
                        },
                    },
                );
            },

            /** 是否有暫存 */
            hasSnapshot: function() {
                return this.$public.notNull(this.$store.state.pageSnapshot[this.$route.name]);
            },
            /** 從暫存中恢復本頁的資料 */
            restoreSnapshot: function() {
                // console.log(`restoreSnapshot !`);
                let regData = this.$store.state.pageSnapshot[this.$route.name];
                if (this.$public.notNull(regData)) {
                    this.lng = regData.lng;
                    this.lat = regData.lat;
                    this.currentPage = regData.currentPage;
                    this.activeName = regData.activeName;
                    this.typeList = regData.typeList;       //第一層分類, type 的種類list
                    this.tagList = regData.tagList;       //第二層分類, tag 的種類list
                    this.brandList = regData.brandList;
                    this.storeList = regData.storeList;
                    this.searchType = regData.searchType;
                    this.filterTab = regData.filterTab;      //點選到的第一層分類
                    this.filterTag = regData.filterTag;      //點選到的第二層分類
                    // this.setupListData = regData.setupListData;
                    // this.infiniteLoadingListState = regData.infiniteLoadingListState;
                    // this.setupListData = false;
                    // this.infiniteLoadingListState = '';
                    this.scrollTo = regData.scrollTo;
                    this.offsetHeight = regData.offsetHeight;

                    // console.log(`restoreSnapshot : brandList length:${this.brandList.length}, storeList length:${this.storeList.length}, currentPage:${this.currentPage}`);
                }
                //清除頁面暫存
                this.$store.commit("savePageSnapshot",{routeName: this.$route.name, variable: undefined});

                if (this.$refs.infiniteLoading) {
                    // console.log(`reset infiniteLoading`);
                    this.$refs.infiniteLoading.stateChanger.reset();
                }
            },

            /** 回復店家列表捲動狀態 */
            restoreScroll: function() {

                if (this.$public.notNull(this.scrollTo) && this.scrollTo !== '') {

                    //手機版紀錄捲動位置
                    let object = this.$refs.main

                    //網頁版紀錄捲動位置
                    const fullWidth = window.innerWidth;
                    if(fullWidth>=1024){
                        object = this.$refs.BigMain
                    }

                    if (this.$public.notNull(object)) {
                        if (this.offsetHeight === object.offsetHeight) {
                            object.scrollTo(0, this.scrollTo);
                        }
                    }
                    this.scrollTo = '';
                }
            },

            /** 取得目前點到的分類按鈕的名稱 */
            getFilterBtnName: function() {
                return (this.filterTab===null || this.filterTab===undefined)?'':this.filterTab.name;
            },

            /** tag是否已被選擇 */
            isTagActive: function(tagName) {
                let result = false;
                if ( this.$public.notNull(this.filterTag) &&
                    this.$public.notNull(tagName)) {
                    result = (this.filterTag.name === tagName);
                }
                // console.log(`onTabClick: ${result}`);
                return result;
            },

            /** 點擊tab */
            onTabClick: function(tabName) {
                console.log(`onTabClick : ${tabName}`);

                let error = false;
                switch(tabName) {
                    case 'first':
                        this.searchType = 2;
                        break;
                    case 'second':
                        this.searchType = 0;
                        break;
                    case 'third':
                        this.searchType = 1;
                        break;
                    default:
                        error = true;
                        break;
                }


                if (error) {
                    console.log('onTabClick error');
                } else {
                    //如果重複點同樣的 tab，就不會更新 router，但會清除過濾條件及重抓資料
                    if (this.activeName !== tabName) {
                        this.activeName = tabName;
                        this.$router.replace({name: this.$route.name, query:{activeName:tabName, searchType:this.searchType}});
                    }
                    this.resetFilter();
                    this.setupData();
                }

            },
            /** 重置過濾 */
            resetFilter: function() {
                this.filterTab = null;      //點選到的第一層分類
                this.filterTag = null;
            },
            /** 初始化 */
            init: function() {
                this.currentPage = 0;
                this.brandList = [];
                this.storeList = [];
            },
            startLoading() {
                let self = this;
                self.isLoading = false;
                setTimeout(function(){
                    // console.log(`startLoading infiniteLoadingListState`);
                    if (!self.setupListData) {
                        self.setupListData = true;
                        if (self.infiniteLoadingListState !==  '') {
                            self.infiniteLoadingListState.reset();
                        }
                    }

                    //改變 infiniteInfinite，並且畫面已經捲到底，才能讓 infinite-loading觸發載入事件
                    self.infiniteInfinite += 1;
                },100)
            },
            /** 初始設定 */
            setupData: function () {
                // 切換tab後先暫停套件，等gps定位完成後再繼續載入，避免載入相同的資料
                if (this.infiniteLoadingListState !== '') {
                    this.infiniteLoadingListState.complete();
                }
                this.init();

                let self = this;
                self.isLoading = true;
                self.getGpsLocation()
                    .then( () => {
                        self.startLoading();
                    })
                    .catch( (error) => {
                        self.startLoading();
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });
            },

            /** 載入更多 */
            setupDataScroll: function ($state) {
                // console.log('## setupDataScroll: ' + JSON.stringify($state));
                let self = this;
                self.infiniteLoadingListState = $state
                //self.isLoading = true;
                if (self.searchType === 0){
                    self.getBrandListWithState($state)
                        /*.then( () => {
                          self.isLoading = false;
                        })*/
                        .catch( (error) => {
                          //this.isLoading = false;
                          self.$store.commit(mutationTypes.SHOW_TOAST, error);
                        });
                } else {
                  self.getStoreListWithState($state)
                      /*.then( () => {
                        self.isLoading = false;
                      })*/
                      .catch( (error) => {
                        //this.isLoading = false;
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                      });
                }
            },

            /** 取得GPS位置 */
            getGpsLocation: function () {

                let self = this;
                return new Promise(function(resolve, reject) {
                    let onSuccess = function (position) {
                        self.lng = position.coords.longitude;
                        self.lat = position.coords.latitude;
                        // console.log(`getGpsLocation onSuccess: self.lng:${self.lng}, self.lat:${self.lat}`);
                        //完畢
                        resolve();
                    };

                    let onError = function (error) {
                        // reject("無法定位GPS");
                        //完畢
                        resolve();
                    };

                    self.$public.getGpsLocation(onSuccess, onError);
                });
            },

            /** 取得熱門推薦(品牌)列表 */
            getBrandListWithState: function ($state) {
              let self = this;
              return new Promise(function(resolve, reject) {
                self.$http.fetch`BrandList${{
                    searchType: 0,        // 0: 熱門品牌,  其他: 取得所有品牌
                    storeTypeId: (self.filterTab === null)? undefined: self.filterTab.id,
                    subStoreTypeId: (self.filterTag === null)? undefined: self.filterTag.id,
                }} ${json => {

                  if (self.$public.notNull(json.data)) {
                    //熱門推薦只顯示20筆
                    if (self.searchType === 0){
                      self.brandList.tmz_load_push(...json.data);
                      $state.complete();
                    }
                    //完成
                    resolve();
                  } else {
                    //失敗
                    reject('失敗');
                  }
                }}`;
              });
            },
            /** 取得附近店家列表 */
            getStoreListWithState: function ($state) {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`StoreList${{
                        searchType: self.searchType,  //0：熱門店家、1：最新店家、2：離我最近、3：高度評價、4： 隨機店家
                        offset: self.currentPage,
                        lng: self.lng,
                        lat: self.lat,
                        storeTypeId: (self.filterTab === null)? undefined: self.filterTab.id,
                        subStoreTypeId: (self.filterTag === null)? undefined: self.filterTag.id,
                    }} ${json => {
                        //imgUrl: banner圖片網址, imgLogoUrl: logo圖片網址, frontUrl: 封面
                        if (self.$public.notNull(json.data)) {
                                self.currentPage++;
                                self.storeList.tmz_load_push(...json.data);
                            if (json.data.length >= self.pageSize) {
                                $state.loaded();
                            } else {
                                $state.complete();
                            }
                            //完成
                            resolve();

                        } else {
                            //失敗
                            reject('失敗');
                        }
                    }}`;
                });
            },

            /**
             * 取得店家分類清單
             * @param tagByTypeId:取得子分類tag(如果有傳的話)
             * */
            getStoreTypeList: function (tagByTypeId = 0) {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`StoreTypeList${{
                        storeTypeId: tagByTypeId,
                    }} ${json => {
                        if (json.status) {
                            //完成
                            resolve(json.data);

                        } else {
                            //失敗
                            reject('取得店家分類失敗');
                        }
                    }}`;
                });
            },


            handleClick(id) {
                console.log(id)
            },

            /** 是否顯示備註 */
            isShowRemark: function(storeInfo) {
                let result = false;
                if (this.$public.notNull(storeInfo) && this.$public.notNull(storeInfo.noteStatus) &&
                   this.$public.notNull(storeInfo.title) && this.$public.notNull(storeInfo.notes)) {
                    result = storeInfo.noteStatus &&
                        storeInfo.title !== '' &&
                        storeInfo.notes.length > 0;
                }
                return result ;
            },

            /** 備註 */
            getRemark: function(storeInfo) {
                let result = '';
                if (this.$public.notNull(storeInfo.notes) &&
                    storeInfo.notes.length > 0) {
                    storeInfo.notes.forEach(function (value) {
                        if (value !== '') {
                            result = result + '<p>'+ value ;
                        }
                    })
                }
                return result;
            },

            /** 顯示訊息 dialog */
            /*showDialog: function (msg, cancelable = false) {
                this.dialog.cancelable = cancelable;
                this.dialog.dialogMsg = msg;
                this.dialog.isShowDialog = true;
            },*/

            /** CommDialog 關閉事件 */
            /*onCommDialogClose(result) {
                this.dialog.isShowDialog = false;

                if (result) {
                    this.$router.push({name: 'Login'});
                } else {
                    this.$router.go(-1)
                }
            },*/

            /** 分類標籤開合 */
            tagOpen() {
                document.getElementsByClassName('tag-btn-list')[0].classList.toggle("open")
            },

            /** 過濾按鈕點擊 */
            onFilterTabClick: function(clickItem) {

                //如果點到已點選的 tab，就會恢復成未選擇的狀態
                if (this.$public.notNull(clickItem)) {
                    if (this.$public.notNull(this.filterTab)) {
                        if (this.filterTab.name !== clickItem.name) {
                            this.filterTab = clickItem;
                        } else {
                            this.filterTab = null;
                        }
                    } else {
                        this.filterTab = clickItem;
                    }
                } else {
                    this.filterTab = clickItem;
                }

                this.filterTag = null;

                //重新取得第二層tag
                let self = this;
                self.isLoading = true;

                if(this.$public.notNull(this.filterTab)){
                  self.getStoreTypeList(this.filterTab.id)
                      .then( (data) => {
                        if (data !== undefined &&
                            data !== null) {
                          self.tagList = data;
                        }
                      })
                      .catch( (error) => {
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                      });
                } else {
                  self.tagList = [];
                }

                //重新取得
                this.setupData();

                console.log('onTabClick:' + this.filterTab);
            },

            /** 點擊品牌 */
            onClickBrand: function(brandId) {
                //if (this.isLogin) {
                    this.$router.push({name: 'BrandInfo', query: {"id": brandId}});

                //} else {
                    //沒登入的話就導到登入
                    //this.$router.push({name: 'Login'});
                //}

            },

            /** 點擊店家 */
            onClickStore: function(storeId) {
                //if (this.isLogin) {
                    this.$router.push({name: 'StoreInfo', query: {"id": storeId}});

                //} else {
                    //沒登入的話就導到登入
                    //this.$router.push({name: 'Login'});
                //}
            },

            /** tag點擊 */
            onTagClick: function(clickItem) {

                //如果點到已點選的 tag，就會恢復成未選擇的狀態
                if (this.$public.notNull(clickItem)) {
                    if (this.$public.notNull(this.filterTag)) {
                        if (this.filterTag.name !== clickItem.name) {
                            this.filterTag = clickItem;
                        } else {
                            this.filterTag = null;
                        }
                    } else {
                        this.filterTag = clickItem;
                    }
                } else {
                    this.filterTag = clickItem;
                }

                //重新取得
                this.setupData();

                // console.log('onTagClick:' + this.filterTag);
            },

            /** 是否已登入 */
            /*checkIsLogin: function() {
                let isLogin = this.$auth.isAdminLogin();
                if (isLogin) {
                    return true;

                } else {
                    //沒登入的話就導到登入
                    this.$router.push({name: 'Login'});
                }
            },*/
        },
    }
</script>

<style lang="less" scoped src="../../less/store.less"/>
